var request = require('../js/request.js')

// 周转柜相关API
var cabinetApi = {
	// 查询空闲箱格数量
	getBoxNum: function (data) {
		return request.noPost('/Web/PassBoxPublic/getBoxNum', data)
	},
	// 获取小程序二维码
	getQRCode: function (data) {
		return request.post('/Common/Qrcode/createQrCodeImage', data)
	},
	// web轮询查询取件登录信息
	getFetchLoginInfo: function (data) {
		return request.post('/Web/PassBoxPublic/getFetchLoginInfo', data)
	},
	// web轮询查询存件登录信息
	getStoreLoginInfo: function (data) {
		return request.post('/Web/PassBoxPublic/getStoreLoginInfo', data)
	},
	// web轮询查询快递单号
	getExpressNumber: function (data) {
		return request.post('/Web/PassBoxPublic/getExpressNumber', data)
	},
	// 获取部门列表
	getDepartmentList: function () {
		return request.post('/Web/PassBox/getDepartmentList')
	},
	// 获取用户列表
	getUserList: function (data) {
		return request.post('/Web/PassBox/getUserList', data)
	},
	// 根据手机号码获取用户名称
	getUserByPhone: function (data) {
		return request.post('/Web/PassBox/getUserByPhone', data)
	},
	// 投递
	deliver: function (data) {
		return request.post('/Web/PassBox/deliver', data)
	},
	// 用户取件开箱
	open: function (data) {
		return request.post('/Web/PassBox/open', data)
	},
	// 获取用户的箱格信息
	getBoxList: function (data) {
		return request.post('/Web/PassBox/getBoxList', data)
	},
	// 根据取件码开箱取件
	fetchByOpenPassword: function (data) {
		return request.post('/Web/PassBoxPublic/fetchByOpenPassword', data)
	},
}

// 快递员注册相关API
var expressLoginApi = {
	// 快递员注册
	registerCompanyPourier: function (data) {
		return request.post('/MiniProgram/IcPublic/registerCompanyPourier', data)
	},
}

export {
	cabinetApi,
	expressLoginApi
}



//////////////////
// WEBPACK FOOTER
// ./static/turnoverCabinet/js/api.js
// module id = null
// module chunks = 